module.exports = "/assets/06a5a87ccc445a6251b3d7047e4dac8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/7F.png
// module id = 2239
// module chunks = 0